import React from "react";
import "./rotate.css"; // Import the CSS styles

const RotatingMessage = () => {
  const phoneNumber = "9542762906";
  const message = "Hii, Enquire from Bhookr website";
  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };
  const styles = {
    icon: {
      width: "50px",
      height: "50px",
      display: "block",
      margin: "0 auto",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <a
      href="#"
      className="go-down-btn"
      title="Scroll down"
      onClick={handleClick}
    >
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="80px"
        height="80px"
        viewBox="0 0 100 100"
        enableBackground="new 0 0 100 100"
        xmlSpace="preserve"
      >
        <path
          id="textPath"
          fill="none"
          d="M89.322,50.197c0,22.09-17.91,40-40,40c-22.089,0-40-17.91-40-40 c0-22.089,17.911-40,40-40C71.412,10.197,89.322,28.108,89.322,50.197z"
        />
        <text>
          <textPath xlinkHref="#textPath">
            <tspan x="10">HAVE ANY</tspan>
            <tspan x="47" dx="30">
              DOUBTS,
            </tspan>
            <tspan x="77" dx="60">
              TALK TO
            </tspan>
            <tspan x="107" dx="90">
              US HERE
            </tspan>
          </textPath>
        </text>
      </svg>
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp Icon"
        style={styles.icon}
      />
    </a>
  );
};

export default RotatingMessage;
